interface DaysOfWeekAbbreviation {
    [key: string]: string;
}

export const daysOfWeekAbbreviation: DaysOfWeekAbbreviation = {
    "SUNDAY": "Niedz",
    "MONDAY": "Pon",
    "TUESDAY": "Wt",
    "WEDNESDAY": "Śr",
    "THURSDAY": "Czw",
    "FRIDAY": "Pt",
    "SATURDAY": "Sob"
};

interface DaysOfWeekTranslation {
    [key: string]: string;
}

export const daysOfWeekTranslation: DaysOfWeekTranslation = {
    "SUNDAY": "Niedziela",
    "MONDAY": "Poniedziałek",
    "TUESDAY": "Wtorek",
    "WEDNESDAY": "Środa",
    "THURSDAY": "Czwartek",
    "FRIDAY": "Piątek",
    "SATURDAY": "Sobota"
};

export const daysOrder = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];